import React from "react";
import Card from "components/card";

const QuickFactCard = ({ icon: Icon, label, value, tags, iconColor = "text-indigo-600 dark:text-indigo-400", bgColor = "dark-mode-card", textColor = "muted-text", border = "border-slate-200" }) => {
    return (
        <Card className={`flex flex-col gap-6 rounded-2xl border-2 ${bgColor} ${border} text-slate-900`}>
            <div className="pb-6 p-4">
                <div className="flex items-center gap-2 mb-3">
                    <Icon className={`w-4 h-4 ${iconColor}`} />
                    <h4 className="font-semibold text-[13px] sm:text-[14px] title-text">{label}</h4>
                </div>
                {tags ? (
                    <div className="flex flex-wrap gap-1">
                        {tags.map((tag, index) => (
                            <span key={index} className="inline-flex items-center justify-center rounded-2xl border px-2 py-0.5 font-medium w-fit whitespace-nowrap shrink-0 gap-1 border-transparent bg-slate-50 text-slate-900 text-[10px] sm:text-[11px]">
                                {tag}
                            </span>
                        ))}
                    </div>
                ) : (
                    <p className={`text-[12px] sm:text-[13px] ${textColor} tracking-wide muted-text`}>{value}</p>
                )}
            </div>
        </Card>
    );
};
export default QuickFactCard;